module.exports = __webpack_public_path__ + "img/audio1.c3587feb.png";